<ng-container *transloco="let t; prefix: 'language.switcher'">
  @if (display() === 'menuItem') {
    <a mat-list-item [matMenuTriggerFor]="langMenu">
      {{ t('label') }}
      <span class="lang-item-active">({{ t(activeLang()) }})</span>
    </a>
  } @else {
    <button
      mat-icon-button
      type="button"
      [class]="'globe-icon globe-icon--' + variant()"
      [attr.aria-label]="t('label')"
      [matMenuTriggerFor]="langMenu"
      [matTooltip]="t('label')"
    >
      <mat-icon>language</mat-icon>
    </button>
  }

  <mat-menu #langMenu="matMenu" [xPosition]="display() === 'menuItem' ? 'before' : 'after'">
    @for (lang of enabledLangs; track lang) {
      <button mat-menu-item type="button" [disabled]="isActive(lang)" (click)="setLang(lang)">
        {{ t(lang) }}
      </button>
    }
  </mat-menu>
</ng-container>
